import { Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsBoolean,
  IsIn,
  IsNumber,
  IsOptional,
  IsString,
  Max,
  MaxLength,
  Min,
  ValidateNested,
} from 'class-validator';
import {
  FISHERY_GEAR_CATEGORIES,
  FISHERY_PRODUCTION_METHODS,
} from '../../label/fishery-origin-catalog';
import type { IngredientVerticalOriginEntry } from '../../label/prepackaged-ingredient-vertical-origin';
import { PREPACKAGED_VERTICAL_ORIGIN_REGIMES } from '../../label/prepackaged-vertical-origin';

class IngredientHoneyCountryDto {
  @IsString()
  @MaxLength(20)
  countryCode!: string;

  @Type(() => Number)
  @Min(0)
  @Max(100)
  sharePercent!: number;
}

export class IngredientVerticalOriginEntryDto {
  @IsIn(PREPACKAGED_VERTICAL_ORIGIN_REGIMES)
  regime!: IngredientVerticalOriginEntry['regime'];

  @IsOptional()
  @IsString()
  @MaxLength(20)
  bornIn?: string;

  @IsOptional()
  @IsArray()
  @ArrayMaxSize(20)
  @IsString({ each: true })
  raisedIn?: string[];

  @IsOptional()
  @IsString()
  @MaxLength(20)
  slaughteredIn?: string;

  @IsOptional()
  @IsString()
  @MaxLength(40)
  slaughterhouseApprovalNumber?: string;

  @IsOptional()
  @IsString()
  @MaxLength(20)
  cutIn?: string;

  @IsOptional()
  @IsString()
  @MaxLength(40)
  cuttingPlantApprovalNumber?: string;

  @IsOptional()
  @IsBoolean()
  minced?: boolean;

  @IsOptional()
  @IsString()
  @MaxLength(20)
  preparedIn?: string;

  @IsOptional()
  @IsBoolean()
  thirdCountryInfoUnavailable?: boolean;

  @IsOptional()
  @IsIn(['PIG', 'SHEEP', 'GOAT', 'POULTRY'])
  species?: 'PIG' | 'SHEEP' | 'GOAT' | 'POULTRY';

  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @Min(0)
  slaughterAgeMonths?: number;

  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @Min(0)
  slaughterLiveWeightKg?: number;

  @IsOptional()
  @IsBoolean()
  residenceThresholdMet?: boolean;

  @IsOptional()
  @IsBoolean()
  mincedOrTrimmings?: boolean;

  @IsOptional()
  @IsString()
  @MaxLength(200)
  scientificName?: string;

  @IsOptional()
  @IsIn(FISHERY_PRODUCTION_METHODS)
  productionMethod?: (typeof FISHERY_PRODUCTION_METHODS)[number];

  @IsOptional()
  @IsString()
  @MaxLength(10)
  faoArea?: string;

  @IsOptional()
  @IsString()
  @MaxLength(10)
  faoSubArea?: string;

  @IsOptional()
  @IsString()
  @MaxLength(100)
  waterBody?: string;

  @IsOptional()
  @IsString()
  @MaxLength(20)
  countryCode?: string;

  @IsOptional()
  @IsIn(FISHERY_GEAR_CATEGORIES)
  gearCategory?: (typeof FISHERY_GEAR_CATEGORIES)[number];

  @IsOptional()
  @IsArray()
  @ArrayMaxSize(20)
  @ValidateNested({ each: true })
  @Type(() => IngredientHoneyCountryDto)
  harvestCountries?: IngredientHoneyCountryDto[];

  @IsOptional()
  @IsIn(['EXTRA_VIRGIN', 'VIRGIN', 'COMPOSED', 'POMACE'])
  category?: 'EXTRA_VIRGIN' | 'VIRGIN' | 'COMPOSED' | 'POMACE';

  @IsOptional()
  @IsString()
  @MaxLength(20)
  oliveHarvestPlace?: string;

  @IsOptional()
  @IsString()
  @MaxLength(20)
  millPlace?: string;

  @IsOptional()
  @IsIn(['SINGLE', 'EU', 'NON_EU', 'EU_AND_NON_EU'])
  blend?: 'SINGLE' | 'EU' | 'NON_EU' | 'EU_AND_NON_EU';

  @IsOptional()
  @IsString()
  @MaxLength(100)
  protectedDesignation?: string;

  @IsOptional()
  @IsString()
  @MaxLength(20)
  milkingCountry?: string;

  @IsOptional()
  @IsString()
  @MaxLength(20)
  wheatGrowingCountry?: string;

  @IsOptional()
  @IsString()
  @MaxLength(20)
  millingCountry?: string;

  @IsOptional()
  @IsString()
  @MaxLength(20)
  growingCountry?: string;
}
